/* eslint-disable */
import React from 'react';

import './employee-card.css';

import { DefaultHumanAvatar } from '../../../../../../../../../common/constants';
import { Image } from '../../../../../../../../../components';

type EmployeeCardType = {
  containerClassName?: string;
  empName?: string;
  profileImage?: string;
};

export function EmployeeCard({
  containerClassName,
  empName,
  profileImage,
}: EmployeeCardType) {
  return (
    <div className={`emp-card ${containerClassName}`}>
      <Image
        className="emp-card-img"
        src={profileImage || DefaultHumanAvatar}
      />
      <div className="emp-name-section">
        <p className="emp-name">{empName}</p>
      </div>
    </div>
  );
}
